export const Filters = () => (
  <div className="col col-6">
    <div className="filter-block">
      <div className="icon"></div>
      <div className="select-block">
        <select
          name=""
          id=""
          className="custom-select custom-select__filter"
          data-placeholder="ID"
          data-select2-id="lessonn"
        >
          <option value=""></option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
          <option value="lesson1">Економіка</option>
        </select>
      </div>
      <div className="select-block">
        <select
          name=""
          id=""
          className="custom-select custom-select__filter"
          data-placeholder="Виплата"
          data-select2-id="worktype"
        >
          <option value=""></option>
          <option value="worktype1">Курсова робота</option>
          <option value="worktype1">Курсова робота</option>
          <option value="worktype1">Курсова робота</option>
          <option value="worktype1">Курсова робота</option>
          <option value="worktype1">Курсова робота</option>
          <option value="worktype1">Курсова робота</option>
          <option value="worktype1">Курсова робота</option>
        </select>
      </div>
    </div>
  </div>
);
